import { Typography } from "@mui/material";
export type ComponentsTooltipProps = {
  items: {
    name: string;
    value: string | number | undefined;
  }[];
};
export default function TreeChartTooltip(props: ComponentsTooltipProps) {
  return (
    <div style={{ minWidth: "100px" }} className="d-flex flex-column">
      {props.items.map((item, index) => (
        <div
          key={index}
          className="d-flex flex-row w-100 justify-content-between"
        >
          <Typography style={{ fontSize: 10, marginRight: 10 }}>
            {item.name}:
          </Typography>
          <Typography style={{ fontSize: 10 }}>{item.value}</Typography>
        </div>
      ))}
    </div>
  );
}

// alias) type Inverters = {
//     amount?: number | undefined;
//     inverterPower?: number | undefined;
//     producers?: Producer[] | undefined;
// }
// import Inverters
